import React from 'react'
import AppRoutes from './@react-fefmwk/app/modules/AppRoutes'

class App extends React.Component {
    render() {
        return <AppRoutes />
    }
}

export default App